import { useState } from 'react';

import { ActionBar, FilterPanel, Header, MarginPosition, StyledFlex } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { AddPatientAction } from './AddPatientAction';
import { PatientSearch } from './PatientSearch';
import { PatientTable } from './PatientTable/PatientTable';
import { PatientFilterPanel } from './filters/PatientFilterPanel';
import { PatientFilterPanelFormBean } from './filters/PatientFilterPanel.types';
import { PATIENT_FILTER_PANEL_DEFAULT_VALUES } from './PatientListPanel.constants';

const PatientListPanel = (): JSX.Element => {
   const [searchText, setSearchText] = useState<string | null>(null);

   return (
      <FilterPanel.Provider<PatientFilterPanelFormBean>
         storageKeyPrefix={'egabinet-desktop'}
         defaultValues={PATIENT_FILTER_PANEL_DEFAULT_VALUES}
      >
         <ActionBar id='patient-list-action-bar' testId='patient'>
            <StyledFlex gap={18} direction={'column'} flex={'1'}>
               <StyledFlex gap={16} alignItems={'center'}>
                  <Header margin={MarginPosition.NONE} testId={'patientSearch'}>
                     {patientTranslationKeys.heading}
                  </Header>
                  <StyledFlex justifyContent={'space-between'} flex={'1'}>
                     <PatientSearch onPatientSearchChanged={setSearchText} />
                     <FilterPanel.VisibilitySwitch />
                  </StyledFlex>
               </StyledFlex>

               <PatientFilterPanel />

               <PatientTable searchText={searchText} />
            </StyledFlex>

            <AddPatientAction />
         </ActionBar>
      </FilterPanel.Provider>
   );
};

export { PatientListPanel };
